function lngLatsToLatLngs(lngLats) {

    return lngLats.map(lngLat => [lngLat[1], lngLat[0]]);

}

export default lngLatsToLatLngs;
